import { Route, Routes, useParams } from 'react-router-dom';
import { NotFoundPage } from '../NotFoundPage';
import { NotificationsProvider } from '../../notifications/Notifications';
import { AttributeCreateModal } from './components/AttributeCreateModal';
import { AttributeModal } from './components/AttributeModal';
import { AttributesPage, useAttributesPageContext } from './AttributesPage';
import { getAttributeDisplayLabels } from './builtInLabels';
import { isAttributeEntityType } from './contracts';
import { useCloseAttributeModal } from './useCloseAttributeModal';

function AttributesPageRouteWrapper() {
    const { entity, id } = useParams();

    if (!isAttributeEntityType(entity) || !id) {
        return <NotFoundPage />;
    }

    return <AttributesPage entityType={entity} entityId={id} />;
}

function AttributeModalRouteWrapper() {
    const { definitionId } = useParams();
    const { entityType, entityId, entries, loading, refetchAttributes } =
        useAttributesPageContext();
    const closeModal = useCloseAttributeModal(entityType, entityId);
    const entryIndex = entries.findIndex(
        (candidate) => candidate.definitionId === definitionId || candidate.key === definitionId
    );
    const entry = entries[entryIndex];

    if (loading && !entry) {
        return null;
    }

    if (!definitionId || !entry) {
        return <NotFoundPage />;
    }

    return (
        <NotificationsProvider registerGlobalRef={false}>
            <AttributeModal
                entry={entry}
                displayLabel={
                    getAttributeDisplayLabels(entries, (candidate) => candidate.label)[entryIndex]
                }
                entityType={entityType}
                entityId={entityId}
                onClose={closeModal}
                onAfterMutation={refetchAttributes}
            />
        </NotificationsProvider>
    );
}

function AttributeCreateModalRouteWrapper() {
    const { entityType, entityId, refetchAttributes } = useAttributesPageContext();
    const closeModal = useCloseAttributeModal(entityType, entityId);

    return (
        <NotificationsProvider registerGlobalRef={false}>
            <AttributeCreateModal
                entityType={entityType}
                entityId={entityId}
                onClose={closeModal}
                onAfterMutation={refetchAttributes}
            />
        </NotificationsProvider>
    );
}

export function AttributesRoutes() {
    return (
        <Routes>
            <Route path=":id" element={<AttributesPageRouteWrapper />}>
                <Route path="new" element={<AttributeCreateModalRouteWrapper />} />
                <Route path=":definitionId" element={<AttributeModalRouteWrapper />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
}
